export function forEachNode (nodes, func) {
  Array.slice.call([], nodes).forEach(func)
}



// WEBPACK FOOTER //
// ./src/shared/forEachNode.js